import React, { useEffect, useState } from 'react';
import { Cell, Pie, PieChart, ResponsiveContainer, Sector, Tooltip } from 'recharts';
import { convertIntoISO } from '../../../Helpers';
import TabButton from '../../UI/TabButton';
import TabsContainer from '../../UI/TabsContainer';
import classes from './AgeGroup.module.css';
import { ageGroupOptions, patientType } from '../../../data';
import CustomDropdown from '../../UI/CustomDropdown';
import CustomLegend from '../CustomLegend';
const COLORS = ['#A88FF3', '#3FC380', '#87CEEB', '#E74C3C'];
const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text x={x} y={y} fill="white" textAnchor="middle" dominantBaseline="central">
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

const AgeGroup = ({ patientFlow = [], dateRange, onFilter }) => {
  const [selectedAge, setSelectedAge] = useState(ageGroupOptions[0]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [data, setData] = useState([]);
  const [selectedType, setSelectedType] = useState(patientType[0]);
  // Convert patientFlow into a usable format
  useEffect(() => {
    if (patientFlow) {
      setData(
        patientFlow?.map((data) => ({
          name: data?.dataCaption,
          value: data?.data,
          numbers: +data?.dataValue || 0.01
        }))
      );
    }
  }, [patientFlow]);

  const onPieEnter = (_, index) => setActiveIndex(index);
  const onPieLeave = () => setActiveIndex(null);

  const renderActiveShape = (props) => {
    const { cx = '50%', cy = '50%', innerRadius, outerRadius, startAngle, endAngle, fill } = props;
    return (
      <g>
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius + 8} // Increase outer radius for effect
          startAngle={startAngle}
          endAngle={endAngle}
          fill={fill}
          stroke="white"
          strokeWidth={5}
          style={{
            filter: 'drop-shadow(4px 4px 6px rgba(0, 0, 0, 0.3))',
            transition: 'all 0.8s ease-out'
          }}
        />
      </g>
    );
  };

  return (
    <div className={classes.innerWrapper}>
      <div className={classes.headingInfo}>
        <h2>age Group</h2>
        <CustomDropdown
          options={ageGroupOptions}
          value={selectedAge}
          setter={(e) => {
            setSelectedAge(e);
          }}
        />
      </div>
      {/* === inner tabs for gender === */}
      <TabsContainer
        className={classes.tabsContainer}
        tabsContent={patientType?.map((tab) => (
          <TabButton
            tab={tab?.label}
            active={tab?.label === selectedType?.label}
            onClick={() => {
              onFilter({
                // startUtcDate: '2025-01-29T06:47:25.689Z',
                // endUtcDate: '2025-01-29T06:47:25.689Z',
                chartType: tab?.value,
                startUtcDate: convertIntoISO(dateRange[0]?.startDate),
                endUtcDate: convertIntoISO(dateRange[0]?.endDate),
                ageGroupId: 0
              });
              setSelectedType(tab);
            }}
          />
        ))}>
        <div className={classes.chartWrapper}>
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                label={renderCustomizedLabel}
                data={data}
                cx="50%"
                cy="50%"
                innerRadius={0}
                outerRadius="60%"
                paddingAngle={0}
                dataKey="numbers"
                onMouseEnter={onPieEnter}
                onMouseLeave={onPieLeave}
                activeIndex={activeIndex}
                fill="#82ca9d"
                labelLine={false}
                activeShape={renderActiveShape}>
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>
        <ul>
          {data?.map((data, index) => (
            <CustomLegend {...{ ...data, color: COLORS[index] }} />
          ))}
        </ul>
      </TabsContainer>
    </div>
  );
};

export default AgeGroup;
